/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FlightPaymentApprovalProjection
 */
export interface FlightPaymentApprovalProjection {
    /**
     * 
     * @type {string}
     * @memberof FlightPaymentApprovalProjection
     */
    paymentOperationId: string;
    /**
     * 
     * @type {string}
     * @memberof FlightPaymentApprovalProjection
     */
    operationType: FlightPaymentApprovalProjectionOperationTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof FlightPaymentApprovalProjection
     */
    amountMinor: number;
    /**
     * 
     * @type {string}
     * @memberof FlightPaymentApprovalProjection
     */
    currency: string;
    /**
     * 
     * @type {string}
     * @memberof FlightPaymentApprovalProjection
     */
    state: FlightPaymentApprovalProjectionStateEnum;
    /**
     * 
     * @type {string}
     * @memberof FlightPaymentApprovalProjection
     */
    evidenceDigest: string;
    /**
     * 
     * @type {Date}
     * @memberof FlightPaymentApprovalProjection
     */
    approvedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof FlightPaymentApprovalProjection
     */
    approverUserId?: string;
    /**
     * 
     * @type {string}
     * @memberof FlightPaymentApprovalProjection
     */
    approverEmail?: string;
}


/**
 * @export
 */
export const FlightPaymentApprovalProjectionOperationTypeEnum = {
    AuthorizationRelease: 'authorization_release',
    CustomerRefund: 'customer_refund'
} as const;
export type FlightPaymentApprovalProjectionOperationTypeEnum = typeof FlightPaymentApprovalProjectionOperationTypeEnum[keyof typeof FlightPaymentApprovalProjectionOperationTypeEnum];

/**
 * @export
 */
export const FlightPaymentApprovalProjectionStateEnum = {
    AwaitingApproval: 'awaiting_approval',
    Approved: 'approved'
} as const;
export type FlightPaymentApprovalProjectionStateEnum = typeof FlightPaymentApprovalProjectionStateEnum[keyof typeof FlightPaymentApprovalProjectionStateEnum];


/**
 * Check if a given object implements the FlightPaymentApprovalProjection interface.
 */
export function instanceOfFlightPaymentApprovalProjection(value: object): value is FlightPaymentApprovalProjection {
    if (!('paymentOperationId' in value) || value['paymentOperationId'] === undefined) return false;
    if (!('operationType' in value) || value['operationType'] === undefined) return false;
    if (!('amountMinor' in value) || value['amountMinor'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('evidenceDigest' in value) || value['evidenceDigest'] === undefined) return false;
    return true;
}

export function FlightPaymentApprovalProjectionFromJSON(json: any): FlightPaymentApprovalProjection {
    return FlightPaymentApprovalProjectionFromJSONTyped(json, false);
}

export function FlightPaymentApprovalProjectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): FlightPaymentApprovalProjection {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentOperationId': json['payment_operation_id'],
        'operationType': json['operation_type'],
        'amountMinor': json['amount_minor'],
        'currency': json['currency'],
        'state': json['state'],
        'evidenceDigest': json['evidence_digest'],
        'approvedAt': json['approved_at'] == null ? undefined : (new Date(json['approved_at'])),
        'approverUserId': json['approver_user_id'] == null ? undefined : json['approver_user_id'],
        'approverEmail': json['approver_email'] == null ? undefined : json['approver_email'],
    };
}

export function FlightPaymentApprovalProjectionToJSON(json: any): FlightPaymentApprovalProjection {
    return FlightPaymentApprovalProjectionToJSONTyped(json, false);
}

export function FlightPaymentApprovalProjectionToJSONTyped(value?: FlightPaymentApprovalProjection | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'payment_operation_id': value['paymentOperationId'],
        'operation_type': value['operationType'],
        'amount_minor': value['amountMinor'],
        'currency': value['currency'],
        'state': value['state'],
        'evidence_digest': value['evidenceDigest'],
        'approved_at': value['approvedAt'] == null ? value['approvedAt'] : value['approvedAt'].toISOString(),
        'approver_user_id': value['approverUserId'],
        'approver_email': value['approverEmail'],
    };
}

